module.exports = __webpack_public_path__ + "img/PHONE_CALL.ae95a554.svg";